import { emailConnect as service } from '../base/services';
import Endpoint from '../base/endpoint';

const multiEmailLogin = new Endpoint(service, 'post', '/multi/login');

export default {
  multiEmailLogin
};
